import styles from "../attaching-objects-to-task-modal.module.css";
import CustomSelect from "@/components/inputs/CustomSelect";
import CloseIcon from "@/icons/CloseIcon";
import PlusIcon from "@/icons/PlusIcon";
import { Button, Card, Col, Flex, Form, InputNumber, Row } from "antd";

const NestedSourcesBlock = ({
  form,
  field,
  sourceField,
  tableOptions,
  relatedOptionsMap,
  removeSource,
}) => {
  return (
    <>
      <Card
        style={{
          background: "#F7F7F7",
          borderColor: "#e9e9e9",
          boxShadow: "none",
          width: "100%",
          marginBottom: 10,
          position: "relative",
        }}
      >
        <Button
          style={{
            position: "absolute",
            right: 12,
            top: 12,
            zIndex: 1,
          }}
          type="text"
          size="small"
          icon={<CloseIcon />}
          onClick={() => removeSource(sourceField.name)}
        />
        <Row>
          <Col xs={24}>
            <Form.Item
              name={[sourceField.name, "field_uuid"]}
              fieldKey={[sourceField.fieldKey, "field_uuid"]}
              label="Источник связанного ресурса"
              rules={[
                {
                  required: true,
                  message: "Выберите источник",
                },
              ]}
            >
              <CustomSelect
                placeholder="Начните вводить"
                options={tableOptions}
                showSearch
                allowClear
                optionLabelProp="label"
                optionFilterProp="searchLabel"
                style={{ width: "100%" }}
                onChange={(value) => {
                  const objects = form.getFieldValue("objects") || [];

                  const newObjects = [...objects];

                  const obj = newObjects[field.name];

                  if (obj?.sources?.[sourceField.name]) {
                    obj.sources[sourceField.name] = {
                      ...obj.sources[sourceField.name],
                      field_uuid: value || undefined,
                      resources:  [{ quantity: 1 }],
                    };
                  }

                  form.setFieldsValue({
                    objects: newObjects,
                  });
                }}
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.List name={[sourceField.name, "resources"]}>
          {(resourceFields, { add: addResource, remove: removeResource }) => {
            const parentObjectUuid = form.getFieldValue([
              "objects",
              field.name,
              "object_uuid",
            ]);

            const tableName = form.getFieldValue([
              "objects",
              field.name,
              "sources",
              sourceField.name,
              "field_uuid",
            ]);

            const isSourceSelected = !!tableName;

            const key = `${parentObjectUuid}_${tableName}`;
            return (
              <>
                {resourceFields.map((resourceField, index) => {
                  const allSources =
                    form.getFieldValue(["objects", field.name, "sources"]) ||
                    [];

                  const selectedRelatedUuids = allSources
                    .flatMap((source) => source?.resources || [])
                    .map((res) => res?.object_uuid)
                    .filter(Boolean);

                  const currentValue = form.getFieldValue([
                    "objects",
                    field.name,
                    "sources",
                    sourceField.name,
                    "resources",
                    resourceField.name,
                    "object_uuid",
                  ]);

                  const optionsWithDisabled = (
                    relatedOptionsMap[key] || []
                  ).map((opt) => ({
                    ...opt,
                    disabled:
                      opt.value !== currentValue &&
                      selectedRelatedUuids.includes(opt.value),
                  }));
                  return (
                    <div key={resourceField.key} style={{ marginBottom: 6 }}>
                      <Row
                        gutter={{
                          xs: 5,
                          sm: 5,
                          md: 10,
                          lg: 10,
                        }}
                        align="start"
                      >
                        <Col xs={24} sm={15}>
                          <Form.Item
                            style={{
                              marginTop: 6,
                              marginBottom: 0,
                            }}
                            name={[resourceField.name, "object_uuid"]}
                            fieldKey={[resourceField.fieldKey, "object_uuid"]}
                            label={index === 0 ? "Связанный ресурс" : null}
                            rules={[
                              {
                                required: true,
                                message: "Выберите связанный ресурс",
                              },
                            ]}
                          >
                            <CustomSelect
                              placeholder="Начните вводить"
                              options={optionsWithDisabled}
                              disabled={!isSourceSelected}
                              showSearch
                              allowClear
                              optionLabelProp="label"
                              optionFilterProp="searchLabel"
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} sm={9}>
                          <Flex justify="space-between" align="end" gap={10}>
                            <Form.Item
                              style={{
                                marginTop: 6,
                                marginBottom: 0,
                              }}
                              name={[resourceField.name, "quantity"]}
                              fieldKey={[resourceField.fieldKey, "quantity"]}
                              label={index === 0 ? `Количество` : null}
                              className="w-100"
                            >
                              <InputNumber
                                disabled={!isSourceSelected}
                                min={1}
                                className="w-100"
                              />
                            </Form.Item>
                            <Button
                              type="text"
                              icon={<CloseIcon />}
                              onClick={() => removeResource(resourceField.name)}
                              disabled={resourceFields.length < 2}
                            />
                          </Flex>
                        </Col>
                      </Row>
                    </div>
                  );
                })}
                {isSourceSelected && (
                  <Button
                    type="link"
                    icon={<PlusIcon />}
                    block
                    style={{ padding: 0, color: "#777777", alignSelf: "start" }}
                    className={styles.addObjectButton}
                    onClick={() => addResource({ quantity: 1 })}
                  >
                    Добавить еще
                  </Button>
                )}
              </>
            );
          }}
        </Form.List>
      </Card>
    </>
  );
};

export default NestedSourcesBlock;
